// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fredoka:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Cross-Platform Compatible */

:root {
  /* Color variables with fallbacks */
  --primary-light: #667eea;
  --primary-dark: #2d1b69;
  --secondary-light: #764ba2;
  --secondary-dark: #11998e;
  --accent-orange: #fbbf24;
  --accent-orange-dark: #f59e0b;
  --text-white: #ffffff;
  --text-white-90: rgba(255, 255, 255, 0.9);
  --glass-light: rgba(255, 255, 255, 0.15);
  --glass-border: rgba(255, 255, 255, 0.2);

  /* Gradients */
  --bg-light: linear-gradient(135deg, #667eea, #764ba2);
  --bg-dark: linear-gradient(135deg, #2d1b69, #11998e);
  --text-gradient-light: linear-gradient(45deg, #fff, #f0f9ff);
  --text-gradient-accent: linear-gradient(45deg, #fbbf24, #f59e0b);
  --button-gradient: linear-gradient(135deg, #ff6b6b, #ff8e53);

  /* Viewport units with fallbacks */
  --vh: 1vh;
  --vw: 1vw;
  --actual-vh: 100vh;
  --actual-vw: 100vw;

  /* Safe area insets with fallbacks */
  --safe-top: 0px;
  --safe-bottom: 0px;
  --safe-left: 0px;
  --safe-right: 0px;

  /* Navigation height */
  --nav-height: 0px;
}

/* Enhanced feature detection and fallbacks */
@supports (padding: env(safe-area-inset-top)) {
  :root {
    --safe-top: env(safe-area-inset-top, 0px);
    --safe-bottom: env(safe-area-inset-bottom, 0px);
    --safe-left: env(safe-area-inset-left, 0px);
    --safe-right: env(safe-area-inset-right, 0px);
  }
}

/* Base styles with cross-browser compatibility */
*, *::before, *::after {
  box-sizing: border-box;
}

html {
  background-color: var(--primary-light);
  background-color: #667eea; /* Fallback */
  height: 100%;
  min-height: 100%;
  overflow-x: hidden;
  /* Better text rendering */
  text-size-adjust: 100%;
  /* Smooth scrolling with fallback */
  scroll-behavior: smooth;
}

body {
  background-color: var(--primary-light);
  background-color: #667eea; /* Fallback */
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Fredoka', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  color: var(--text-white);
  color: white; /* Fallback */

  /* Enhanced overscroll behavior */
  overscroll-behavior-x: none;
  overscroll-behavior-y: auto;
  -webkit-overscroll-behavior-x: none;
  -webkit-overscroll-behavior-y: auto;
  -webkit-overflow-scrolling: touch;

  /* Better font rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  /* Performance optimizations */
  /* transform: translateZ(0); */
  /* will-change: scroll-position;   */
}

/* =========================
   NAVIGATION STYLES
   ========================= */
.navigation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  padding-top: var(--safe-top);
  height: calc(var(--nav-height) + var(--safe-top));
  transform: translateZ(0);
}

.navigation.scrolled {
  background: rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.no-backdrop-filter .navigation {
  background: rgba(102, 126, 234, 0.95);
}

.no-backdrop-filter .navigation.scrolled {
  background: rgba(102, 126, 234, 0.98);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: var(--nav-height);
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 1.25rem;
  color: white;
  text-decoration: none;
  transform: translateZ(0);
}

.nav-logo {
  font-size: 1.5rem;
  animation: bounce 2s infinite;
}

.nav-title {
  background: var(--text-gradient-light);
  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: white; /* Fallback */
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
  transform: translateZ(0);
}

.nav-item:hover,
.nav-item:focus {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px) translateZ(0);
}

.nav-item.active {
  color: white;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.1);
}

.nav-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  gap: 4px;
  transform: translateZ(0);
}

.nav-toggle span {
  width: 24px;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

/* Mobile Navigation */
@media (max-width: 768px) {
  .nav-container {
    padding: 0 16px;
  }

  .nav-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    flex-direction: column;
    gap: 0;
    padding: 20px 0;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: 1001;
  }

  .no-backdrop-filter .nav-menu {
    background: rgba(102, 126, 234, 0.95);
  }

  .nav-menu.open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-item {
    width: 100%;
    text-align: center;
    padding: 16px 24px;
    border-radius: 0;
    color: white;
    font-weight: 600;
    font-size: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .nav-item:last-child {
    border-bottom: none;
  }

  .nav-item:hover,
  .nav-item:focus,
  .nav-item.active {
    background: rgba(255, 255, 255, 0.2);
    color: white;
  }

  .nav-toggle {
    display: flex;
    z-index: 1002;
  }

  .nav-menu.open + .nav-toggle span:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
  }

  .nav-menu.open + .nav-toggle span:nth-child(2) {
    opacity: 0;
  }

  .nav-menu.open + .nav-toggle span:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }
}

/* =========================
   SECTION STYLES
   ========================= */
.section {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
padding: calc(var(--nav-height) + 40px) 0 80px;
}

.hero-section {
  min-height: 100vh;
  min-height: var(--actual-vh);
  min-height: calc(var(--nav-height + 5, 1vh) * 100);
  padding-bottom: 40px;
}

.content-section {
  min-height: auto;
  padding: 80px 0;
  background: rgba(255, 255, 255, 0.02);
}

/* Remove alternating section colors - keep consistent */
.content-section:nth-child(even) {
  background: rgba(255, 255, 255, 0.02);
}

.section-content {
  max-width: 1200px;
  width: 100%;
  padding: 0 24px;
  text-align: center;
}

.section-content h2 {
  font-size: clamp(2rem, 6vw, 3rem);
  font-weight: 700;
  margin-bottom: 2rem;
  background: var(--text-gradient-light);
  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: white; /* Fallback */
}

.section-content p {
  font-size: clamp(1.1rem, 3vw, 1.2rem);
  line-height: 1.6;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto 2rem;
}

/* About Section Styles */
.about-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.about-feature {
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.15); /* Fallback */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 2rem 1.5rem;
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */
  transition: transform 0.3s ease;
  transform: translateZ(0);
}

.about-feature:hover {
  transform: translateY(-5px) translateZ(0);
}

.about-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.about-feature h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: white;
}

.about-feature p {
  font-size: 1rem;
  line-height: 1.5;
  opacity: 0.8;
  margin: 0;
}

/* Testimonials Section Styles */
.testimonials-preview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.testimonial {
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.15); /* Fallback */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */
  text-align: left;
  transform: translateZ(0);
}

.testimonial p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-style: italic;
}

.testimonial span {
  font-weight: 600;
  opacity: 0.8;
  font-size: 0.9rem;
}

/* Contact Section Styles */
.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.contact-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.15); /* Fallback */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 2rem 1.5rem;
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */
  transition: transform 0.3s ease;
  transform: translateZ(0);
  cursor: pointer;
}

.contact-item:hover {
  transform: translateY(-5px) translateZ(0);
}

.contact-icon {
  font-size: 2.5rem;
}

.contact-item span {
  font-weight: 500;
  text-align: center;
}

/* Fallbacks for backdrop-filter - all use same opacity */
.no-backdrop-filter .about-feature,
.no-backdrop-filter .testimonial,
.no-backdrop-filter .contact-item {
  background: rgba(255, 255, 255, 0.15);
}

.footer {
  padding: 40px 0;
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Dark mode support - consolidated */

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }

  .floating-element {
    transform: none !important;
    opacity: 1 !important;
  }

  .navigation {
    transition: none !important;
  }

  .nav-item {
    transition: none !important;
  }
}

/* Enhanced mobile device support */
.mobile-device {
  /* Better touch handling */
  touch-action: manipulation;
}

.mobile-device * {
  /* Prevent zoom on form inputs */
  font-size: 16px;
}

.mobile-device .cta-button {
  font-size: 16px; /* Prevent zoom on iOS */
  /* Better touch target */
  min-height: 44px;
  min-width: 44px;
}

.mobile-device .nav-item {
  font-size: 16px; /* Prevent zoom on iOS */
  min-height: 44px;
}

/* iOS specific optimizations */
.ios-device {
  /* Better momentum scrolling */
  -webkit-overflow-scrolling: touch;
}

.ios-safari {
  /* Handle Safari's changing viewport */
  height: var(--actual-vh);
  height: 100vh; /* Fallback */
}

.ios-safari .app-container {
  min-height: var(--actual-vh);
  min-height: calc(var(--vh, 1vh) * 100); /* Enhanced fallback */
  min-height: 100vh; /* Basic fallback */
  padding-bottom: calc(var(--safe-bottom) + 20px);
  padding-bottom: 50px; /* Fallback */
}

.ios-safari .main-content {
  min-height: calc(var(--actual-vh) - var(--safe-top) - var(--safe-bottom) - 40px);
  min-height: calc(var(--vh, 1vh) * 100 - 90px); /* Fallback */
  padding-bottom: calc(var(--safe-bottom) + 20px);
  padding-bottom: 40px; /* Fallback */
}

.ios-safari .navigation {
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

/* Android specific optimizations */
.android-device {
  /* Better performance on Android */
  will-change: scroll-position;
}

.android-chrome .app-container {
  /* Handle Chrome's address bar */
  min-height: var(--actual-vh);
  min-height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh; /* Fallback */
}

.android-samsung .app-container {
  /* Samsung browser specific fixes */
  background-attachment: scroll; /* Samsung browser doesn't handle local well */
}

/* High DPI display optimizations */
.high-dpi {
  /* Better rendering on high DPI screens */
  -webkit-font-smoothing: subpixel-antialiased;
}

.high-dpi .logo {
  /* Sharper emoji rendering */
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

/* Main container with enhanced compatibility */
.app-container {
  min-height: 100vh;
  min-height: var(--actual-vh);
  min-height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  width: var(--actual-vw);
  width: calc(var(--vw, 1vw) * 100);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;

  /* Safe area support */
  padding-top: 0; /* Navigation handles top padding */
  padding-bottom: calc(var(--safe-bottom) + 20px);
  padding-bottom: 40px; /* Fallback */
  padding-left: var(--safe-left);
  padding-left: 0px; /* Fallback */
  padding-right: var(--safe-right);
  padding-right: 0px; /* Fallback */

  /* Enhanced gradient background */
  background: var(--bg-light);
  background: linear-gradient(135deg, #667eea, #764ba2); /* Fallback */
  background-size: 100% 150vh;
  background-position: center top;
  background-attachment: local;
  background-repeat: no-repeat;

  /* Performance optimizations */
  transform: translateZ(0);
  will-change: scroll-position;
}

/* Enhanced background elements */
.bg-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  /* Performance optimization */
  transform: translateZ(0);
  will-change: transform;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.1); /* Fallback */
  animation: float 6s ease-in-out infinite;
  /* Performance optimizations */
  transform: translateZ(0);
  will-change: transform;
}

.bg-circle-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: -50px;
  animation-delay: 0s;
}

.bg-circle-2 {
  width: 150px;
  height: 150px;
  top: 70%;
  right: -30px;
  animation-delay: 2s;
}

.bg-circle-3 {
  width: 100px;
  height: 100px;
  top: 40%;
  left: 80%;
  animation-delay: 4s;
}

/* Enhanced main content - Higher specificity for Tailwind compatibility */
.app-container .main-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px !important; /* Force override if needed */
  text-align: center;

  /* Enhanced viewport handling */
  min-height: calc(100vh - var(--nav-height) - var(--safe-top) - var(--safe-bottom) - 40px);
  min-height: calc(var(--vh, 1vh) * 100 - var(--nav-height) - 40px); /* Fallback */
  padding-bottom: calc(var(--safe-bottom) + 20px) !important;
  padding-bottom: 30px !important; /* Fallback */

  /* Performance optimization */
  transform: translateZ(0);
}

/* Enhanced floating elements */
.floating-element {
  opacity: 0;
  transform: translateY(30px) translateZ(0);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  /* Fallback for older browsers */
  transition: all 0.8s ease;
  will-change: transform, opacity;
}

.floating-element.visible {
  opacity: 1;
  transform: translateY(0) translateZ(0);
}

/* Ensure the logo container is centered */
.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Enhanced typography */
.logo {
  font-size: clamp(3rem, 10vw, 4rem);
  margin-bottom: 1rem;
  animation: bounce 2s infinite;
  /* Performance optimization */
  transform: translateZ(0);
  will-change: transform;
}

.title {
  font-size: clamp(2.5rem, 8vw, 4rem);
  font-weight: 700;
  background: var(--text-gradient-light);
  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: white; /* Fallback for unsupported browsers */
  margin: 0;
  line-height: 1.1;
}

/* Fallback for browsers that don't support background-clip: text */
.no-custom-properties .title {
  color: white;
  background: none;
  -webkit-text-fill-color: unset;
}

.tagline {
  font-size: clamp(1.2rem, 4vw, 1.5rem);
  margin-bottom: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}

.highlight {
  background: var(--text-gradient-accent);
  background: linear-gradient(45deg, #fbbf24, #f59e0b); /* Fallback */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: #fbbf24; /* Fallback */
  font-weight: 600;
}

.no-custom-properties .highlight {
  color: #fbbf24;
  background: none;
  -webkit-text-fill-color: unset;
}

.description {
  font-size: clamp(1rem, 3vw, 1.1rem);
  max-width: 600px;
  line-height: 1.6;
  margin-bottom: 3rem;
  opacity: 0.9;
}

/* Enhanced features section */
.features {
  display: flex;
  gap: clamp(1rem, 4vw, 2rem);
  margin-bottom: 3rem;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Enhanced glass effect with fallbacks */
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.15); /* Fallback */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 1.5rem 1rem;
  border-radius: 16px;
  border: 1px solid var(--glass-border);
  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */
  min-width: 140px;
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: transform 0.3s ease; /* Fallback */
  /* Performance optimization */
  transform: translateZ(0);
  will-change: transform;
}

/* Fallback for browsers without backdrop-filter support  */
.no-backdrop-filter .feature {
  background: rgba(255, 255, 255, 0.15);
}

.feature:hover,
.feature:focus {
  transform: translateY(-5px) translateZ(0);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  /* Better emoji rendering */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji', sans-serif;
}

/* Enhanced CTA button */
.cta-button {
  background: var(--button-gradient);
  background: linear-gradient(135deg, #ff6b6b, #ff8e53); /* Fallback */
  border: none;
  padding: 1rem 3rem;
  border-radius: 50px;
  color: var(--text-white);
  color: white; /* Fallback */
  font-size: clamp(1rem, 3vw, 1.1rem);
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: all 0.3s ease; /* Fallback */
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);
  margin-bottom: 1.5rem;
  /* Better touch targets */
  min-height: 44px;
  min-width: 200px;
  /* Performance optimizations */
  transform: translateZ(0);
  will-change: transform, box-shadow;
  /* Better text rendering */
  text-decoration: none;
  font-family: inherit;
}

.cta-button:hover,
.cta-button:focus,
.cta-button.hovered {
  transform: translateY(-3px) translateZ(0);
  box-shadow: 0 12px 35px rgba(255, 107, 107, 0.6);
}

.cta-button:active {
  transform: translateY(-1px) translateZ(0);
}

.button-icon {
  animation: sparkle 1.5s infinite;
  /* Performance optimization */
  transform: translateZ(0);
  will-change: transform;
}

/* Enhanced platform badges */
.platform-badges {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
}

.platform-badge {
  background: var(--glass-light);
  background: rgba(255, 255, 255, 0.15); /* Fallback */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid var(--glass-border);
  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */
  /* Performance optimization */
  transform: translateZ(0);
}

.no-backdrop-filter .platform-badge {
  background: rgba(255, 255, 255, 0.15);
}

.footer-note {
  font-size: 0.9rem;
  opacity: 0.8;
  padding-bottom: calc(var(--safe-bottom) + 10px);
  padding-bottom: 20px; /* Fallback */
  margin-bottom: 10px;
  text-align: center;
}

/* Enhanced animations with better performance */
@keyframes float {
  0%, 100% {
    transform: translateY(0) translateZ(0);
  }
  50% {
    transform: translateY(-20px) translateZ(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) translateZ(0);
  }
  40% {
    transform: translateY(-10px) translateZ(0);
  }
  60% {
    transform: translateY(-5px) translateZ(0);
  }
}

@keyframes sparkle {
  0%, 100% {
    transform: scale(1) translateZ(0);
  }
  50% {
    transform: scale(1.2) translateZ(0);
  }
}

/* Enhanced responsive design */
@media (max-width: 768px) {
  .main-content {
    padding: 16px;
  }

  .features {
    gap: 1rem;
  }

  .feature {
    min-width: 120px;
    padding: 1rem 0.75rem;
    /* Ensure consistent background on mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }

  .platform-badges {
    gap: 0.5rem;
  }

  .platform-badge {
    padding: 6px 12px;
    font-size: 0.8rem;
    /* Ensure consistent background on mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .section-content {
    padding: 0 16px;
  }

  /* New content sections responsive */
  .about-features {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .about-feature {
    padding: 1.5rem 1rem;
    /* Ensure consistent background on mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .about-icon {
    font-size: 2.5rem;
  }

  .testimonials-preview {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .testimonial {
    padding: 1.5rem;
    /* Ensure consistent background on mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .contact-info {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .contact-item {
    padding: 1.5rem 1rem;
    /* Ensure consistent background on mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .contact-icon {
    font-size: 2rem;
  }

  .content-section {
    padding: 60px 0;
    /* Ensure consistent section background on mobile */
    background: rgba(255, 255, 255, 0.02);
  }

  .section {
    padding: calc(var(--nav-height) + 20px) 0 60px;
  }

  /* Override backdrop-filter fallbacks on mobile for consistency */
  .no-backdrop-filter .feature,
  .no-backdrop-filter .platform-badge,
  .no-backdrop-filter .about-feature,
  .no-backdrop-filter .testimonial,
  .no-backdrop-filter .contact-item {
    background: rgba(255, 255, 255, 0.15);
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 12px;
  }

  .description {
    margin-bottom: 2rem;
  }

  .features {
    margin-bottom: 2rem;
  }

  .feature {
    /* Maintain consistent background on small mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .platform-badge {
    /* Maintain consistent background on small mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .section-content {
    padding: 0 12px;
  }

  .about-features {
    gap: 1rem;
    margin-top: 1.5rem;
  }

  .about-feature {
    padding: 1.25rem 0.75rem;
    /* Maintain consistent background on small mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .about-feature h3 {
    font-size: 1.1rem;
  }

  .about-feature p {
    font-size: 0.9rem;
  }

  .testimonials-preview {
    gap: 1rem;
    margin-top: 1.5rem;
  }

  .testimonial {
    padding: 1.25rem;
    /* Maintain consistent background on small mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .testimonial p {
    font-size: 1rem;
  }

  .contact-info {
    gap: 1rem;
    margin-top: 1.5rem;
  }

  .contact-item {
    padding: 1.25rem 0.75rem;
    /* Maintain consistent background on small mobile */
    background: rgba(255, 255, 255, 0.15);
  }

  .contact-item span {
    font-size: 0.9rem;
  }

  .content-section {
    padding: 40px 0;
    /* Maintain consistent section background on small mobile */
    background: rgba(255, 255, 255, 0.02);
  }

  .section {
    padding: calc(var(--nav-height) + 20px) 0 40px;
  }

  /* Override backdrop-filter fallbacks on small mobile for consistency */
  .no-backdrop-filter .feature,
  .no-backdrop-filter .platform-badge,
  .no-backdrop-filter .about-feature,
  .no-backdrop-filter .testimonial,
  .no-backdrop-filter .contact-item {
    background: rgba(255, 255, 255, 0.15);
  }
}

/* Dark mode updates for new sections */
@media (prefers-color-scheme: dark) {
  html {
    background-color: var(--primary-dark);
    background-color: #2d1b69; /* Fallback */
  }

  body {
    background-color: var(--primary-dark);
    background-color: #2d1b69; /* Fallback */
  }

  .app-container {
    background: var(--bg-dark);
    background: linear-gradient(135deg, #2d1b69, #11998e); /* Fallback */
  }

  .content-section {
    background: rgba(255, 255, 255, 0.02);
  }

  .content-section:nth-child(even) {
    background: rgba(255, 255, 255, 0.02);
  }

  .navigation {
    background: rgba(255, 255, 255, 0.08);
  }

  .navigation.scrolled {
    background: rgba(255, 255, 255, 0.12);
  }

  .no-backdrop-filter .navigation {
    background: rgba(45, 27, 105, 0.95);
  }

  .no-backdrop-filter .navigation.scrolled {
    background: rgba(45, 27, 105, 0.98);
  }

  .no-backdrop-filter .nav-menu {
    background: rgba(45, 27, 105, 0.95);
  }
  
  /* Mobile dark mode navigation */
  @media (max-width: 768px) {
    .no-backdrop-filter .nav-menu {
      background: rgba(45, 27, 105, 0.95);
    }
    
    /* Dark mode mobile glass effects consistency */
    .content-section {
      background: rgba(255, 255, 255, 0.02);
    }
    
    .feature,
    .platform-badge,
    .about-feature,
    .testimonial,
    .contact-item {
      background: rgba(255, 255, 255, 0.15);
    }
    
    .no-backdrop-filter .feature,
    .no-backdrop-filter .platform-badge,
    .no-backdrop-filter .about-feature,
    .no-backdrop-filter .testimonial,
    .no-backdrop-filter .contact-item {
      background: rgba(255, 255, 255, 0.15);
    }
  }
  
  @media (max-width: 480px) {
    /* Dark mode small mobile consistency */
    .content-section {
      background: rgba(255, 255, 255, 0.02);
    }
    
    .feature,
    .platform-badge,
    .about-feature,
    .testimonial,
    .contact-item {
      background: rgba(255, 255, 255, 0.15);
    }
    
    .no-backdrop-filter .feature,
    .no-backdrop-filter .platform-badge,
    .no-backdrop-filter .about-feature,
    .no-backdrop-filter .testimonial,
    .no-backdrop-filter .contact-item {
      background: rgba(255, 255, 255, 0.15);
    }
  }
  
  .no-backdrop-filter .about-feature,
  .no-backdrop-filter .testimonial,
  .no-backdrop-filter .contact-item {
    background: rgba(255, 255, 255, 0.15);
  }
}

/* Enhanced accessibility */
@media (prefers-contrast: high) {
  .feature {
    border: 2px solid rgba(255, 255, 255, 0.6);
  }
  
  .platform-badge {
    border: 2px solid rgba(255, 255, 255, 0.6);
  }
  
  .cta-button {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
  }
  
  .navigation {
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  }
  
  .nav-item.active {
    border: 2px solid rgba(255, 255, 255, 0.5);
  }
}

/* Focus styles for better accessibility */
.cta-button:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
}

.feature:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
}

.nav-item:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
}

.nav-toggle:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAGxC;EACE,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,yCAAyC;EACzC,wCAAwC;EACxC,wCAAwC;;EAExC,cAAc;EACd,qDAAqD;EACrD,oDAAoD;EACpD,4DAA4D;EAC5D,gEAAgE;EAChE,4DAA4D;;EAE5D,kCAAkC;EAClC,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,kBAAkB;;EAElB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE;IACE,yCAAyC;IACzC,+CAA+C;IAC/C,2CAA2C;IAC3C,6CAA6C;EAC/C;AACF;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB,EAAE,aAAa;EACxC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAG1B,sBAAsB;EACtB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB,EAAE,aAAa;EACxC,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oHAAoH;EACpH,wBAAwB;EACxB,YAAY,EAAE,aAAa;;EAE3B,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,iCAAiC;;EAEjC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;;EAElC,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;;8BAE8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,yDAAyD;EACzD,4BAA4B;EAC5B,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,iDAAiD,EAAE,aAAa;EAChE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,iDAAiD;IACjD,yCAAyC;IACzC,sBAAsB;IACtB,MAAM;IACN,eAAe;IACf,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,yDAAyD;IACzD,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA;;8BAE8B;AAC9B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB,8CAA8C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,iDAAiD,EAAE,aAAa;EAChE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC,EAAE,aAAa;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C,EAAE,aAAa;EACzD,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC,EAAE,aAAa;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C,EAAE,aAAa;EACzD,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,qCAAqC,EAAE,aAAa;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C,EAAE,aAAa;EACzD,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA,qCAAqC;;AAErC,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,wBAAwB;EACzC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,wBAAwB;EACzC,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,aAAa,EAAE,aAAa;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC,EAAE,sBAAsB;EAC9D,iBAAiB,EAAE,mBAAmB;EACtC,+CAA+C;EAC/C,oBAAoB,EAAE,aAAa;AACrC;;AAEA;EACE,gFAAgF;EAChF,6CAA6C,EAAE,aAAa;EAC5D,+CAA+C;EAC/C,oBAAoB,EAAE,aAAa;AACrC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,sCAAsC;EACtC,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B,EAAE,8CAA8C;AAC/E;;AAEA,mCAAmC;AACnC;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;;EAEhB,sBAAsB;EACtB,cAAc,EAAE,mCAAmC;EACnD,+CAA+C;EAC/C,oBAAoB,EAAE,aAAa;EACnC,8BAA8B;EAC9B,iBAAiB,EAAE,aAAa;EAChC,gCAAgC;EAChC,kBAAkB,EAAE,aAAa;;EAEjC,iCAAiC;EACjC,2BAA2B;EAC3B,qDAAqD,EAAE,aAAa;EACpE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;;EAE5B,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC,EAAE,aAAa;EACnD,wCAAwC;EACxC,8BAA8B;EAC9B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB,EAAE,6BAA6B;EACvD,kBAAkB;;EAElB,+BAA+B;EAC/B,yFAAyF;EACzF,iEAAiE,EAAE,aAAa;EAChF,0DAA0D;EAC1D,+BAA+B,EAAE,aAAa;;EAE9C,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,yCAAyC;EACzC,yDAAyD;EACzD,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,sCAAsC;EACtC,iDAAiD,EAAE,aAAa;EAChE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,YAAY,EAAE,sCAAsC;EACpD,SAAS;EACT,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,oDAAoD,EAAE,aAAa;EACnE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,8BAA8B;EAC9B,qCAAqC,EAAE,aAAa;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C,EAAE,aAAa;EACzD,gBAAgB;EAChB,+DAA+D;EAC/D,+BAA+B,EAAE,aAAa;EAC9C,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,2DAA2D;AAC3D;EACE,qCAAqC;AACvC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,mHAAmH;AACrH;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,qDAAqD,EAAE,aAAa;EACpE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY,EAAE,aAAa;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yDAAyD;EACzD,yBAAyB,EAAE,aAAa;EACxC,+CAA+C;EAC/C,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;;EAGE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC,EAAE,aAAa;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C,EAAE,aAAa;EACzD,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,+CAA+C;EAC/C,oBAAoB,EAAE,aAAa;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE;IACE,sCAAsC;EACxC;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,mCAAmC;EACrC;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,8CAA8C;EAChD;;EAEA,iEAAiE;EACjE;;;;;IAKE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,mDAAmD;IACnD,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,2DAA2D;IAC3D,qCAAqC;EACvC;;EAEA;IACE,8CAA8C;EAChD;;EAEA,uEAAuE;EACvE;;;;;IAKE,qCAAqC;EACvC;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,qCAAqC;IACrC,yBAAyB,EAAE,aAAa;EAC1C;;EAEA;IACE,qCAAqC;IACrC,yBAAyB,EAAE,aAAa;EAC1C;;EAEA;IACE,0BAA0B;IAC1B,qDAAqD,EAAE,aAAa;EACtE;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA,gCAAgC;EAChC;IACE;MACE,mCAAmC;IACrC;;IAEA,+CAA+C;IAC/C;MACE,qCAAqC;IACvC;;IAEA;;;;;MAKE,qCAAqC;IACvC;;IAEA;;;;;MAKE,qCAAqC;IACvC;EACF;;EAEA;IACE,uCAAuC;IACvC;MACE,qCAAqC;IACvC;;IAEA;;;;;MAKE,qCAAqC;IACvC;;IAEA;;;;;MAKE,qCAAqC;IACvC;EACF;;EAEA;;;IAGE,qCAAqC;EACvC;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB","sourcesContent":["/* App.css - Cross-Platform Compatible */\n@import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@300;400;500;600;700&display=swap');\n\n:root {\n  /* Color variables with fallbacks */\n  --primary-light: #667eea;\n  --primary-dark: #2d1b69;\n  --secondary-light: #764ba2;\n  --secondary-dark: #11998e;\n  --accent-orange: #fbbf24;\n  --accent-orange-dark: #f59e0b;\n  --text-white: #ffffff;\n  --text-white-90: rgba(255, 255, 255, 0.9);\n  --glass-light: rgba(255, 255, 255, 0.15);\n  --glass-border: rgba(255, 255, 255, 0.2);\n\n  /* Gradients */\n  --bg-light: linear-gradient(135deg, #667eea, #764ba2);\n  --bg-dark: linear-gradient(135deg, #2d1b69, #11998e);\n  --text-gradient-light: linear-gradient(45deg, #fff, #f0f9ff);\n  --text-gradient-accent: linear-gradient(45deg, #fbbf24, #f59e0b);\n  --button-gradient: linear-gradient(135deg, #ff6b6b, #ff8e53);\n\n  /* Viewport units with fallbacks */\n  --vh: 1vh;\n  --vw: 1vw;\n  --actual-vh: 100vh;\n  --actual-vw: 100vw;\n\n  /* Safe area insets with fallbacks */\n  --safe-top: 0px;\n  --safe-bottom: 0px;\n  --safe-left: 0px;\n  --safe-right: 0px;\n\n  /* Navigation height */\n  --nav-height: 0px;\n}\n\n/* Enhanced feature detection and fallbacks */\n@supports (padding: env(safe-area-inset-top)) {\n  :root {\n    --safe-top: env(safe-area-inset-top, 0px);\n    --safe-bottom: env(safe-area-inset-bottom, 0px);\n    --safe-left: env(safe-area-inset-left, 0px);\n    --safe-right: env(safe-area-inset-right, 0px);\n  }\n}\n\n/* Base styles with cross-browser compatibility */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  background-color: var(--primary-light);\n  background-color: #667eea; /* Fallback */\n  height: 100%;\n  min-height: 100%;\n  overflow-x: hidden;\n  /* Better text rendering */\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  /* Smooth scrolling with fallback */\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: var(--primary-light);\n  background-color: #667eea; /* Fallback */\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: 'Fredoka', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  color: var(--text-white);\n  color: white; /* Fallback */\n\n  /* Enhanced overscroll behavior */\n  overscroll-behavior-x: none;\n  overscroll-behavior-y: auto;\n  -webkit-overscroll-behavior-x: none;\n  -webkit-overscroll-behavior-y: auto;\n  -webkit-overflow-scrolling: touch;\n\n  /* Better font rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n\n  /* Performance optimizations */\n  /* transform: translateZ(0); */\n  /* will-change: scroll-position;   */\n}\n\n/* =========================\n   NAVIGATION STYLES\n   ========================= */\n.navigation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  padding-top: var(--safe-top);\n  height: calc(var(--nav-height) + var(--safe-top));\n  transform: translateZ(0);\n}\n\n.navigation.scrolled {\n  background: rgba(255, 255, 255, 0.2);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.no-backdrop-filter .navigation {\n  background: rgba(102, 126, 234, 0.95);\n}\n\n.no-backdrop-filter .navigation.scrolled {\n  background: rgba(102, 126, 234, 0.98);\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: var(--nav-height);\n}\n\n.nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: white;\n  text-decoration: none;\n  transform: translateZ(0);\n}\n\n.nav-logo {\n  font-size: 1.5rem;\n  animation: bounce 2s infinite;\n}\n\n.nav-title {\n  background: var(--text-gradient-light);\n  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: white; /* Fallback */\n}\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-item {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.8);\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 20px;\n  transition: all 0.3s ease;\n  position: relative;\n  transform: translateZ(0);\n}\n\n.nav-item:hover,\n.nav-item:focus {\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px) translateZ(0);\n}\n\n.nav-item.active {\n  color: white;\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.1);\n}\n\n.nav-toggle {\n  display: none;\n  flex-direction: column;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  gap: 4px;\n  transform: translateZ(0);\n}\n\n.nav-toggle span {\n  width: 24px;\n  height: 2px;\n  background: white;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n/* Mobile Navigation */\n@media (max-width: 768px) {\n  .nav-container {\n    padding: 0 16px;\n  }\n\n  .nav-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: rgba(255, 255, 255, 0.15);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n    flex-direction: column;\n    gap: 0;\n    padding: 20px 0;\n    transform: translateY(-100%);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n    z-index: 1001;\n  }\n\n  .no-backdrop-filter .nav-menu {\n    background: rgba(102, 126, 234, 0.95);\n  }\n\n  .nav-menu.open {\n    transform: translateY(0);\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .nav-item {\n    width: 100%;\n    text-align: center;\n    padding: 16px 24px;\n    border-radius: 0;\n    color: white;\n    font-weight: 600;\n    font-size: 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .nav-item:last-child {\n    border-bottom: none;\n  }\n\n  .nav-item:hover,\n  .nav-item:focus,\n  .nav-item.active {\n    background: rgba(255, 255, 255, 0.2);\n    color: white;\n  }\n\n  .nav-toggle {\n    display: flex;\n    z-index: 1002;\n  }\n\n  .nav-menu.open + .nav-toggle span:nth-child(1) {\n    transform: rotate(45deg) translate(6px, 6px);\n  }\n\n  .nav-menu.open + .nav-toggle span:nth-child(2) {\n    opacity: 0;\n  }\n\n  .nav-menu.open + .nav-toggle span:nth-child(3) {\n    transform: rotate(-45deg) translate(6px, -6px);\n  }\n}\n\n/* =========================\n   SECTION STYLES\n   ========================= */\n.section {\n  min-height: 100vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\npadding: calc(var(--nav-height) + 40px) 0 80px;\n}\n\n.hero-section {\n  min-height: 100vh;\n  min-height: var(--actual-vh);\n  min-height: calc(var(--nav-height + 5, 1vh) * 100);\n  padding-bottom: 40px;\n}\n\n.content-section {\n  min-height: auto;\n  padding: 80px 0;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n/* Remove alternating section colors - keep consistent */\n.content-section:nth-child(even) {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.section-content {\n  max-width: 1200px;\n  width: 100%;\n  padding: 0 24px;\n  text-align: center;\n}\n\n.section-content h2 {\n  font-size: clamp(2rem, 6vw, 3rem);\n  font-weight: 700;\n  margin-bottom: 2rem;\n  background: var(--text-gradient-light);\n  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: white; /* Fallback */\n}\n\n.section-content p {\n  font-size: clamp(1.1rem, 3vw, 1.2rem);\n  line-height: 1.6;\n  opacity: 0.9;\n  max-width: 600px;\n  margin: 0 auto 2rem;\n}\n\n/* About Section Styles */\n.about-features {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.about-feature {\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.15); /* Fallback */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 2rem 1.5rem;\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */\n  transition: transform 0.3s ease;\n  transform: translateZ(0);\n}\n\n.about-feature:hover {\n  transform: translateY(-5px) translateZ(0);\n}\n\n.about-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.about-feature h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.about-feature p {\n  font-size: 1rem;\n  line-height: 1.5;\n  opacity: 0.8;\n  margin: 0;\n}\n\n/* Testimonials Section Styles */\n.testimonials-preview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.testimonial {\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.15); /* Fallback */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 2rem;\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */\n  text-align: left;\n  transform: translateZ(0);\n}\n\n.testimonial p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n  font-style: italic;\n}\n\n.testimonial span {\n  font-weight: 600;\n  opacity: 0.8;\n  font-size: 0.9rem;\n}\n\n/* Contact Section Styles */\n.contact-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.contact-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.15); /* Fallback */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 2rem 1.5rem;\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */\n  transition: transform 0.3s ease;\n  transform: translateZ(0);\n  cursor: pointer;\n}\n\n.contact-item:hover {\n  transform: translateY(-5px) translateZ(0);\n}\n\n.contact-icon {\n  font-size: 2.5rem;\n}\n\n.contact-item span {\n  font-weight: 500;\n  text-align: center;\n}\n\n/* Fallbacks for backdrop-filter - all use same opacity */\n.no-backdrop-filter .about-feature,\n.no-backdrop-filter .testimonial,\n.no-backdrop-filter .contact-item {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.footer {\n  padding: 40px 0;\n  background: rgba(255, 255, 255, 0.02);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Dark mode support - consolidated */\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n\n  .floating-element {\n    transform: none !important;\n    opacity: 1 !important;\n  }\n\n  .navigation {\n    transition: none !important;\n  }\n\n  .nav-item {\n    transition: none !important;\n  }\n}\n\n/* Enhanced mobile device support */\n.mobile-device {\n  /* Better touch handling */\n  touch-action: manipulation;\n}\n\n.mobile-device * {\n  /* Prevent zoom on form inputs */\n  font-size: 16px;\n}\n\n.mobile-device .cta-button {\n  font-size: 16px; /* Prevent zoom on iOS */\n  /* Better touch target */\n  min-height: 44px;\n  min-width: 44px;\n}\n\n.mobile-device .nav-item {\n  font-size: 16px; /* Prevent zoom on iOS */\n  min-height: 44px;\n}\n\n/* iOS specific optimizations */\n.ios-device {\n  /* Better momentum scrolling */\n  -webkit-overflow-scrolling: touch;\n}\n\n.ios-safari {\n  /* Handle Safari's changing viewport */\n  height: var(--actual-vh);\n  height: 100vh; /* Fallback */\n}\n\n.ios-safari .app-container {\n  min-height: var(--actual-vh);\n  min-height: calc(var(--vh, 1vh) * 100); /* Enhanced fallback */\n  min-height: 100vh; /* Basic fallback */\n  padding-bottom: calc(var(--safe-bottom) + 20px);\n  padding-bottom: 50px; /* Fallback */\n}\n\n.ios-safari .main-content {\n  min-height: calc(var(--actual-vh) - var(--safe-top) - var(--safe-bottom) - 40px);\n  min-height: calc(var(--vh, 1vh) * 100 - 90px); /* Fallback */\n  padding-bottom: calc(var(--safe-bottom) + 20px);\n  padding-bottom: 40px; /* Fallback */\n}\n\n.ios-safari .navigation {\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n/* Android specific optimizations */\n.android-device {\n  /* Better performance on Android */\n  will-change: scroll-position;\n}\n\n.android-chrome .app-container {\n  /* Handle Chrome's address bar */\n  min-height: var(--actual-vh);\n  min-height: calc(var(--vh, 1vh) * 100);\n  min-height: 100vh; /* Fallback */\n}\n\n.android-samsung .app-container {\n  /* Samsung browser specific fixes */\n  background-attachment: scroll; /* Samsung browser doesn't handle local well */\n}\n\n/* High DPI display optimizations */\n.high-dpi {\n  /* Better rendering on high DPI screens */\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n\n.high-dpi .logo {\n  /* Sharper emoji rendering */\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n}\n\n/* Main container with enhanced compatibility */\n.app-container {\n  min-height: 100vh;\n  min-height: var(--actual-vh);\n  min-height: calc(var(--vh, 1vh) * 100);\n  width: 100vw;\n  width: var(--actual-vw);\n  width: calc(var(--vw, 1vw) * 100);\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  /* Safe area support */\n  padding-top: 0; /* Navigation handles top padding */\n  padding-bottom: calc(var(--safe-bottom) + 20px);\n  padding-bottom: 40px; /* Fallback */\n  padding-left: var(--safe-left);\n  padding-left: 0px; /* Fallback */\n  padding-right: var(--safe-right);\n  padding-right: 0px; /* Fallback */\n\n  /* Enhanced gradient background */\n  background: var(--bg-light);\n  background: linear-gradient(135deg, #667eea, #764ba2); /* Fallback */\n  background-size: 100% 150vh;\n  background-position: center top;\n  background-attachment: local;\n  background-repeat: no-repeat;\n\n  /* Performance optimizations */\n  transform: translateZ(0);\n  will-change: scroll-position;\n}\n\n/* Enhanced background elements */\n.bg-elements {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n  /* Performance optimization */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.bg-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.1); /* Fallback */\n  animation: float 6s ease-in-out infinite;\n  /* Performance optimizations */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.bg-circle-1 {\n  width: 200px;\n  height: 200px;\n  top: 10%;\n  left: -50px;\n  animation-delay: 0s;\n}\n\n.bg-circle-2 {\n  width: 150px;\n  height: 150px;\n  top: 70%;\n  right: -30px;\n  animation-delay: 2s;\n}\n\n.bg-circle-3 {\n  width: 100px;\n  height: 100px;\n  top: 40%;\n  left: 80%;\n  animation-delay: 4s;\n}\n\n/* Enhanced main content - Higher specificity for Tailwind compatibility */\n.app-container .main-content {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px !important; /* Force override if needed */\n  text-align: center;\n\n  /* Enhanced viewport handling */\n  min-height: calc(100vh - var(--nav-height) - var(--safe-top) - var(--safe-bottom) - 40px);\n  min-height: calc(var(--vh, 1vh) * 100 - var(--nav-height) - 40px); /* Fallback */\n  padding-bottom: calc(var(--safe-bottom) + 20px) !important;\n  padding-bottom: 30px !important; /* Fallback */\n\n  /* Performance optimization */\n  transform: translateZ(0);\n}\n\n/* Enhanced floating elements */\n.floating-element {\n  opacity: 0;\n  transform: translateY(30px) translateZ(0);\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  /* Fallback for older browsers */\n  transition: all 0.8s ease;\n  will-change: transform, opacity;\n}\n\n.floating-element.visible {\n  opacity: 1;\n  transform: translateY(0) translateZ(0);\n}\n\n/* Ensure the logo container is centered */\n.logo-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Enhanced typography */\n.logo {\n  font-size: clamp(3rem, 10vw, 4rem);\n  margin-bottom: 1rem;\n  animation: bounce 2s infinite;\n  /* Performance optimization */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.title {\n  font-size: clamp(2.5rem, 8vw, 4rem);\n  font-weight: 700;\n  background: var(--text-gradient-light);\n  background: linear-gradient(45deg, #fff, #f0f9ff); /* Fallback */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: white; /* Fallback for unsupported browsers */\n  margin: 0;\n  line-height: 1.1;\n}\n\n/* Fallback for browsers that don't support background-clip: text */\n.no-custom-properties .title {\n  color: white;\n  background: none;\n  -webkit-text-fill-color: unset;\n}\n\n.tagline {\n  font-size: clamp(1.2rem, 4vw, 1.5rem);\n  margin-bottom: 1.5rem;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.highlight {\n  background: var(--text-gradient-accent);\n  background: linear-gradient(45deg, #fbbf24, #f59e0b); /* Fallback */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  color: #fbbf24; /* Fallback */\n  font-weight: 600;\n}\n\n.no-custom-properties .highlight {\n  color: #fbbf24;\n  background: none;\n  -webkit-text-fill-color: unset;\n}\n\n.description {\n  font-size: clamp(1rem, 3vw, 1.1rem);\n  max-width: 600px;\n  line-height: 1.6;\n  margin-bottom: 3rem;\n  opacity: 0.9;\n}\n\n/* Enhanced features section */\n.features {\n  display: flex;\n  gap: clamp(1rem, 4vw, 2rem);\n  margin-bottom: 3rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n}\n\n.feature {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* Enhanced glass effect with fallbacks */\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.15); /* Fallback */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 1.5rem 1rem;\n  border-radius: 16px;\n  border: 1px solid var(--glass-border);\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */\n  min-width: 140px;\n  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: transform 0.3s ease; /* Fallback */\n  /* Performance optimization */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n/* Fallback for browsers without backdrop-filter support  */\n.no-backdrop-filter .feature {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.feature:hover,\n.feature:focus {\n  transform: translateY(-5px) translateZ(0);\n}\n\n.feature-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  /* Better emoji rendering */\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji', sans-serif;\n}\n\n/* Enhanced CTA button */\n.cta-button {\n  background: var(--button-gradient);\n  background: linear-gradient(135deg, #ff6b6b, #ff8e53); /* Fallback */\n  border: none;\n  padding: 1rem 3rem;\n  border-radius: 50px;\n  color: var(--text-white);\n  color: white; /* Fallback */\n  font-size: clamp(1rem, 3vw, 1.1rem);\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition: all 0.3s ease; /* Fallback */\n  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);\n  margin-bottom: 1.5rem;\n  /* Better touch targets */\n  min-height: 44px;\n  min-width: 200px;\n  /* Performance optimizations */\n  transform: translateZ(0);\n  will-change: transform, box-shadow;\n  /* Better text rendering */\n  text-decoration: none;\n  font-family: inherit;\n}\n\n.cta-button:hover,\n.cta-button:focus,\n.cta-button.hovered {\n  transform: translateY(-3px) translateZ(0);\n  box-shadow: 0 12px 35px rgba(255, 107, 107, 0.6);\n}\n\n.cta-button:active {\n  transform: translateY(-1px) translateZ(0);\n}\n\n.button-icon {\n  animation: sparkle 1.5s infinite;\n  /* Performance optimization */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n/* Enhanced platform badges */\n.platform-badges {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  width: 100%;\n}\n\n.platform-badge {\n  background: var(--glass-light);\n  background: rgba(255, 255, 255, 0.15); /* Fallback */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 8px 16px;\n  border-radius: 30px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  border: 1px solid var(--glass-border);\n  border: 1px solid rgba(255, 255, 255, 0.2); /* Fallback */\n  /* Performance optimization */\n  transform: translateZ(0);\n}\n\n.no-backdrop-filter .platform-badge {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.footer-note {\n  font-size: 0.9rem;\n  opacity: 0.8;\n  padding-bottom: calc(var(--safe-bottom) + 10px);\n  padding-bottom: 20px; /* Fallback */\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n/* Enhanced animations with better performance */\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) translateZ(0);\n  }\n  50% {\n    transform: translateY(-20px) translateZ(0);\n  }\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0) translateZ(0);\n  }\n  40% {\n    transform: translateY(-10px) translateZ(0);\n  }\n  60% {\n    transform: translateY(-5px) translateZ(0);\n  }\n}\n\n@keyframes sparkle {\n  0%, 100% {\n    transform: scale(1) translateZ(0);\n  }\n  50% {\n    transform: scale(1.2) translateZ(0);\n  }\n}\n\n/* Enhanced responsive design */\n@media (max-width: 768px) {\n  .main-content {\n    padding: 16px;\n  }\n\n  .features {\n    gap: 1rem;\n  }\n\n  .feature {\n    min-width: 120px;\n    padding: 1rem 0.75rem;\n    /* Ensure consistent background on mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .cta-button {\n    padding: 0.875rem 2rem;\n    font-size: 1rem;\n  }\n\n  .platform-badges {\n    gap: 0.5rem;\n  }\n\n  .platform-badge {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n    /* Ensure consistent background on mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .section-content {\n    padding: 0 16px;\n  }\n\n  /* New content sections responsive */\n  .about-features {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    margin-top: 2rem;\n  }\n\n  .about-feature {\n    padding: 1.5rem 1rem;\n    /* Ensure consistent background on mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .about-icon {\n    font-size: 2.5rem;\n  }\n\n  .testimonials-preview {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    margin-top: 2rem;\n  }\n\n  .testimonial {\n    padding: 1.5rem;\n    /* Ensure consistent background on mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .contact-info {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    margin-top: 2rem;\n  }\n\n  .contact-item {\n    padding: 1.5rem 1rem;\n    /* Ensure consistent background on mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .contact-icon {\n    font-size: 2rem;\n  }\n\n  .content-section {\n    padding: 60px 0;\n    /* Ensure consistent section background on mobile */\n    background: rgba(255, 255, 255, 0.02);\n  }\n\n  .section {\n    padding: calc(var(--nav-height) + 20px) 0 60px;\n  }\n\n  /* Override backdrop-filter fallbacks on mobile for consistency */\n  .no-backdrop-filter .feature,\n  .no-backdrop-filter .platform-badge,\n  .no-backdrop-filter .about-feature,\n  .no-backdrop-filter .testimonial,\n  .no-backdrop-filter .contact-item {\n    background: rgba(255, 255, 255, 0.15);\n  }\n}\n\n@media (max-width: 480px) {\n  .main-content {\n    padding: 12px;\n  }\n\n  .description {\n    margin-bottom: 2rem;\n  }\n\n  .features {\n    margin-bottom: 2rem;\n  }\n\n  .feature {\n    /* Maintain consistent background on small mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .platform-badge {\n    /* Maintain consistent background on small mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .section-content {\n    padding: 0 12px;\n  }\n\n  .about-features {\n    gap: 1rem;\n    margin-top: 1.5rem;\n  }\n\n  .about-feature {\n    padding: 1.25rem 0.75rem;\n    /* Maintain consistent background on small mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .about-feature h3 {\n    font-size: 1.1rem;\n  }\n\n  .about-feature p {\n    font-size: 0.9rem;\n  }\n\n  .testimonials-preview {\n    gap: 1rem;\n    margin-top: 1.5rem;\n  }\n\n  .testimonial {\n    padding: 1.25rem;\n    /* Maintain consistent background on small mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .testimonial p {\n    font-size: 1rem;\n  }\n\n  .contact-info {\n    gap: 1rem;\n    margin-top: 1.5rem;\n  }\n\n  .contact-item {\n    padding: 1.25rem 0.75rem;\n    /* Maintain consistent background on small mobile */\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .contact-item span {\n    font-size: 0.9rem;\n  }\n\n  .content-section {\n    padding: 40px 0;\n    /* Maintain consistent section background on small mobile */\n    background: rgba(255, 255, 255, 0.02);\n  }\n\n  .section {\n    padding: calc(var(--nav-height) + 20px) 0 40px;\n  }\n\n  /* Override backdrop-filter fallbacks on small mobile for consistency */\n  .no-backdrop-filter .feature,\n  .no-backdrop-filter .platform-badge,\n  .no-backdrop-filter .about-feature,\n  .no-backdrop-filter .testimonial,\n  .no-backdrop-filter .contact-item {\n    background: rgba(255, 255, 255, 0.15);\n  }\n}\n\n/* Dark mode updates for new sections */\n@media (prefers-color-scheme: dark) {\n  html {\n    background-color: var(--primary-dark);\n    background-color: #2d1b69; /* Fallback */\n  }\n\n  body {\n    background-color: var(--primary-dark);\n    background-color: #2d1b69; /* Fallback */\n  }\n\n  .app-container {\n    background: var(--bg-dark);\n    background: linear-gradient(135deg, #2d1b69, #11998e); /* Fallback */\n  }\n\n  .content-section {\n    background: rgba(255, 255, 255, 0.02);\n  }\n\n  .content-section:nth-child(even) {\n    background: rgba(255, 255, 255, 0.02);\n  }\n\n  .navigation {\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  .navigation.scrolled {\n    background: rgba(255, 255, 255, 0.12);\n  }\n\n  .no-backdrop-filter .navigation {\n    background: rgba(45, 27, 105, 0.95);\n  }\n\n  .no-backdrop-filter .navigation.scrolled {\n    background: rgba(45, 27, 105, 0.98);\n  }\n\n  .no-backdrop-filter .nav-menu {\n    background: rgba(45, 27, 105, 0.95);\n  }\n  \n  /* Mobile dark mode navigation */\n  @media (max-width: 768px) {\n    .no-backdrop-filter .nav-menu {\n      background: rgba(45, 27, 105, 0.95);\n    }\n    \n    /* Dark mode mobile glass effects consistency */\n    .content-section {\n      background: rgba(255, 255, 255, 0.02);\n    }\n    \n    .feature,\n    .platform-badge,\n    .about-feature,\n    .testimonial,\n    .contact-item {\n      background: rgba(255, 255, 255, 0.15);\n    }\n    \n    .no-backdrop-filter .feature,\n    .no-backdrop-filter .platform-badge,\n    .no-backdrop-filter .about-feature,\n    .no-backdrop-filter .testimonial,\n    .no-backdrop-filter .contact-item {\n      background: rgba(255, 255, 255, 0.15);\n    }\n  }\n  \n  @media (max-width: 480px) {\n    /* Dark mode small mobile consistency */\n    .content-section {\n      background: rgba(255, 255, 255, 0.02);\n    }\n    \n    .feature,\n    .platform-badge,\n    .about-feature,\n    .testimonial,\n    .contact-item {\n      background: rgba(255, 255, 255, 0.15);\n    }\n    \n    .no-backdrop-filter .feature,\n    .no-backdrop-filter .platform-badge,\n    .no-backdrop-filter .about-feature,\n    .no-backdrop-filter .testimonial,\n    .no-backdrop-filter .contact-item {\n      background: rgba(255, 255, 255, 0.15);\n    }\n  }\n  \n  .no-backdrop-filter .about-feature,\n  .no-backdrop-filter .testimonial,\n  .no-backdrop-filter .contact-item {\n    background: rgba(255, 255, 255, 0.15);\n  }\n}\n\n/* Enhanced accessibility */\n@media (prefers-contrast: high) {\n  .feature {\n    border: 2px solid rgba(255, 255, 255, 0.6);\n  }\n  \n  .platform-badge {\n    border: 2px solid rgba(255, 255, 255, 0.6);\n  }\n  \n  .cta-button {\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);\n  }\n  \n  .navigation {\n    border-bottom: 2px solid rgba(255, 255, 255, 0.3);\n  }\n  \n  .nav-item.active {\n    border: 2px solid rgba(255, 255, 255, 0.5);\n  }\n}\n\n/* Focus styles for better accessibility */\n.cta-button:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}\n\n.feature:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}\n\n.nav-item:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}\n\n.nav-toggle:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
